import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { BaseLineClose } from '@/app/components/icons/BaseLineClose';
import { cn } from '@/app/utils';

interface InfoTipProps {
  message: ReactNode;
  onClose: () => void;
  className?: string;
  prefixIcon?: ReactNode;
  action?: ReactNode;
  autoCloseAfter?: number; // 几秒后自动关闭，单位为秒
}

export const InfoTip = ({ message, onClose, className, prefixIcon, action, autoCloseAfter }: InfoTipProps) => {
  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (autoCloseAfter && autoCloseAfter > 0) {
      timer = setTimeout(() => {
        onClose();
      }, autoCloseAfter * 1000);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [autoCloseAfter]);

  return (
    <div
      className={cn(
        'flex items-center justify-between rounded-8 border border-system-white10 bg-system-black/40 p-3 text-sm',
        className,
      )}
    >
      <span className="flex items-center gap-2 self-start">
        {prefixIcon}
        {message}
      </span>
      <div className="ml-1 flex items-center gap-2">
        {action}
        <BaseLineClose className="cursor-pointer text-sm text-system-white opacity-40" onClick={onClose} />
      </div>
    </div>
  );
};
